/**
 * TradeAnalyser — landing/picker page (Trade Analyser split, Job 1)
 *
 * Mirrors pages/DraftBoard.jsx: one page, full-width dial-icon tiles, one
 * per section (Analyse Your Trade / Trade Radar), stacked vertically.
 * Clicking a tile navigates AWAY to that section's own full page
 * (pages/trade/*.jsx) — this page doesn't stay mounted underneath it. Each
 * section page links back here via ToolHeader's `backRight` prop.
 *
 * The previous single-file implementation (both sections behind an
 * internal `?tab=` switch, ~1130 lines) is gone — see
 * engineering/ARCHIVE/completed-prompts/JAI_TradeAnalyser_Rebuild_Prompt.md for the split rationale.
 */

import { Link, useParams } from 'react-router-dom'
import { useLeagues } from '../context/LeagueContext'
import AppShell from '../components/AppShell'
import ToolHeader from '../components/ToolHeader'
import { JAI_FONTS } from '../components/JaiBrand'
import { V2, V2Dial, V2ToolGlyphs } from '../components/JaiV2'

const SECTIONS = [
  { key: 'analyse', glyph: 'tradeAnalyse', label: 'Analyse Your Trade', sub: 'Pick a manager and a trade — JAI grades it against both real rosters', path: 'analyse' },
  { key: 'radar',   glyph: 'tradeRadar',   label: 'Trade Radar',        sub: 'Trades worth pitching, scanned across your whole league',          path: 'radar' },
]

export default function TradeAnalyser() {
  const { id } = useParams()
  const { leagues } = useLeagues()
  const league = leagues.find(l => l.id === Number(id))

  return (
    <AppShell>
      <div style={{ padding: '30px 40px', fontFamily: JAI_FONTS.tight }}>
        <div style={{ maxWidth: 880, margin: '0 auto', paddingBottom: 100 }}>
          <ToolHeader
            leagueName={league?.name}
            title="Trade Analyser"
            back={{ label: 'Go to League Home Screen', to: `/league/${id}` }}
          />

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {SECTIONS.map(section => (
              <Link
                key={section.key}
                to={`/league/${id}/trade/${section.path}`}
                style={{
                  display: 'flex', alignItems: 'center', gap: 20,
                  width: '100%', textDecoration: 'none',
                  background: 'white', border: `1px solid ${V2.hairSoft}`, borderRadius: 16,
                  padding: '26px 28px', transition: 'border-color 180ms, box-shadow 180ms',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(30,91,214,0.3)'; e.currentTarget.style.boxShadow = V2.cardShadow }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = V2.hairSoft; e.currentTarget.style.boxShadow = 'none' }}
              >
                <V2Dial size={56}>{V2ToolGlyphs[section.glyph]}</V2Dial>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <div style={{ fontSize: 17, fontWeight: 800, color: V2.navy, letterSpacing: '0.02em', textTransform: 'uppercase', marginBottom: 3 }}>{section.label}</div>
                  <div style={{ fontSize: 13, color: V2.mute }}>{section.sub}</div>
                </div>
                <span style={{ fontSize: 20, color: V2.faint, flexShrink: 0 }}>&rarr;</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </AppShell>
  )
}
